import { FunctionComponent } from 'react'
import { use2FAValidation } from './actions/use2FAValidation'

const GlobalActions: FunctionComponent = () => {
  use2FAValidation()

  return null
}

export { GlobalActions }
